/**
 * Represents a timing event based on a performance measurement.
 * @class
 * @param {PerformanceMeasure} measure - A User Timing performance measurement.
 * @returns {TimingEvent} A TimingEvent based on a performance measurement.
 */
function TimingEvent(measure) {
    if (!(this instanceof TimingEvent)) {
        return new TimingEvent(measure);
    }
    const parts = measure.name.split('.');
    if (parts.length < 2) {
        throw new Error('Measure name must have at least two parts delimited by dots to construct a timing event.');
    }

    this.category = parts[0];
    this.var = parts[1];
    this.value = measure.duration;
    this.label = parts[2];
}

module.exports = TimingEvent;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/performance/timing-event.js
 **/